import { registerHydrateSsrComponentList } from './hydrateSsrComponentList';

// Register a new SSR component in build/critical-css/components-defaults.js and vite.config.mjs.

registerHydrateSsrComponentList('dynamic');
